import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { StyledCardsContainer, StyledTableContainer } from './BulletinOpenPlacesStyle';
import './BulletinOpenPlacesTranslate';
import paths from '../../_helpers/paths';
import BreadCrumbs from '../../components/BreadCrumbs/BreadCrumbs';
import { useDispatch, useSelector } from 'react-redux';
import {
  clearState,
  loadBulletins,
  bulletinOpenPlacesModule,
  createDirection
} from './BulletinOpenPlacesDucks';
import { requestsColumns } from './TableColumns/TableColumns';
import Filters from './BulletinOpenPlacesComponents/Filters/Filters.jsx';
import useTableFilter from '../../components/TableFilter/useTableFilter';
import StaticTablePaginated from '../../_ui/Table/StaticTablePaginated';
import Search from './BulletinOpenPlacesComponents/Search/Search';
import i18n from 'i18next';
import useModal from '../../components/_hooks/useModal';
import DialogGetAppointment from './Dialogs/DialogGetAppointment';
import { useLocation, useParams } from 'react-router-dom';
import SuccessfulAppointment from './Dialogs/SuccessfulAppointment';
import DialogVoucher from '../VoucherApplications/Dialogs/DialogVoucher';
import { approveVoucherByApplicant } from '../VoucherApplications/VoucherApplicationsDucks';
import { reserveDdoPlace } from '../VoucherAppointments/VoucherAppointmentsDucks';

function BulletinOpenPlaces() {
  const { t } = useTranslation();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  let lang = i18n.language;
  const dispatch = useDispatch();
  const isForReservePlace = searchParams.get('isForReservePlace') === 'true';
  const breadCrumbItems = [];
  breadCrumbItems.push({ name: t('home_subtitle'), href: paths.homePage });
  breadCrumbItems.push({
    name: t('kindergarten_subtitle'),
    href: paths.kindergartenServices
  });
  breadCrumbItems.push({ name: t('bulletin_op_subtitle') });

  const bulletins = useSelector(state => state[bulletinOpenPlacesModule].data);
  const pageNumber = useSelector(state => state[bulletinOpenPlacesModule].pageNumber);
  const totalElements = useSelector(
    state => state[bulletinOpenPlacesModule].totalElements
  );
  const loading = useSelector(state => state[bulletinOpenPlacesModule].loading);
  const { kqId, voucherId } = useParams();
  const loadData = filter => {
    dispatch(loadBulletins(lang, filter, kqId));
  };
  const { filter, toPage, changePageSize, searchByFilter } = useTableFilter(
    loadData,
    '',
    {
      pageNumber: 1,
      pageSize: 10
    }
  );
  const modal = useModal('getAppointment');
  const modalSuccess = useModal('successfulAppointment');
  const modalApproveVoucher = useModal('voucherApprove');

  const handleDone = data => {
    dispatch(createDirection(data, modal, modalSuccess));
  };
  const handleDoneForApprove = async () => {
    if (isForReservePlace) {
      dispatch(reserveDdoPlace(voucherId, modalApproveVoucher));
    } else {
      dispatch(approveVoucherByApplicant(voucherId, modalApproveVoucher));
    }
  };
  const address = modalApproveVoucher.data
    ? lang === 'ru'
      ? modalApproveVoucher.data.legal_address
      : modalApproveVoucher.data.legal_address_kz
    : '';

  useEffect(() => {
    dispatch(clearState());
  }, [dispatch]);

  return (
    <div className="mb3 mt3" style={{ width: '100%' }}>
      <BreadCrumbs items={breadCrumbItems} />
      <StyledCardsContainer>
        <Filters loading={loading} filter={filter} searchByFilter={searchByFilter} />
        <div>
          <div className="warning">
            <div>
              <b>{t('bulletin_op_warning_title')}</b>
            </div>
            <div style={{ textIndent: '15px' }}>
              {t('bulletin_op_warning_msg_before')}
              {t('bulletin_op_warning_items', { returnObjects: true }).map(
                (item, index) => {
                  return <div key={index}>{item}</div>;
                }
              )}
              {t('bulletin_op_warning_msg_after')}
            </div>
          </div>
          <Search loading={loading} filter={filter} searchByFilter={searchByFilter} />
          {bulletins && (
            <StyledTableContainer>
              <div className="mt2">
                <StaticTablePaginated
                  className="bulletin__ope-places"
                  TheadComponent={_ => null}
                  pageNumber={pageNumber}
                  loading={loading}
                  data={bulletins}
                  totalElements={totalElements}
                  changePageSize={changePageSize}
                  pageSizes={[10, 20, 50, 100]}
                  columns={requestsColumns({
                    t,
                    lang,
                    modal,
                    voucherId,
                    modalApproveVoucher
                  })}
                  filterable={false}
                  pagePagination={page => {
                    if (page !== pageNumber) {
                      toPage(page);
                    }
                  }}
                />
              </div>
            </StyledTableContainer>
          )}
        </div>
      </StyledCardsContainer>
      <SuccessfulAppointment
        open={modalSuccess.isOpen}
        handleClose={modalSuccess.close}
        data={modalSuccess.data}
        lang={lang}
      />
      <DialogGetAppointment
        open={modal.isOpen}
        handleClose={modal.close}
        loading={loading}
        handleDone={handleDone}
        original={modal.data}
        lang={lang}
        KqId={kqId}
      />
      <DialogVoucher
        modalBody={t(
          isForReservePlace
            ? 'voucher_appointments_modalBodyReservePlace'
            : 'voucher_applications_modalBodyApproveVoucher',
          {
            name: modalApproveVoucher.data
              ? modalApproveVoucher.data[`${lang}_name`]
              : '',
            group_name: modalApproveVoucher.data
              ? modalApproveVoucher.data[`name_group_${lang}`]
              : '',
            address: address ? address.replace('/', ' ∕ ') : ''
          }
        )}
        modalTitle={t(
          isForReservePlace
            ? 'kindergarten_appointments_actions_enroll_do'
            : 'voucher_applications_modalTitleApproveVoucher'
        )}
        open={modalApproveVoucher.isOpen}
        handleClose={modalApproveVoucher.close}
        handleDone={handleDoneForApprove}
      />
    </div>
  );
}

export default BulletinOpenPlaces;
